import { APICore } from "helpers/api/apiCore";
import config from "config";

const api = new APICore();
function createNpaReportApi(params: any) {
  let apiData: any = {
    saveReport: params.saveReport
  };
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/npa-report`;
  return api.create(`${backendApiUrl}`, apiData);
}

export { createNpaReportApi };
